<template>
  <v-card
    outlined
    class="dish-card"
    tabindex="0"
    @click="$emit('dish-open', dish.id)"
    @keydown.enter="$emit('dish-open', dish.id)"
  >
    <div class="dish-card__photo">
      <dish-image :src="dish.image"></dish-image>

      <v-chip
        v-if="!dish.image"
        color="warning"
        x-small
        class="dish-card__mark"
      >
        нет фото
      </v-chip>
    </div>

    <div class="pa-3">
      <div
        class="dish-card__name text-body-2 font-weight-medium text--primary"
        :title="dish.name"
      >
        {{ dish.name }}
      </div>
      <div class="text-caption text--secondary text-truncate">
        {{ toWeight(dish.weight) }}
      </div>
      <div class="dish-card__price text-subtitle-2 text--primary mt-1">
        {{ toMoney(dish.price) }}
      </div>
    </div>
  </v-card>
</template>

<script>
import DishImage from './dish-image.vue'
import { toMoney, toWeight } from '@/helpers/menu'

export default {
  name: 'DishCard',
  components: { DishImage },
  props: {
    dish: { type: Object, required: true },
  },
  methods: {
    toMoney,
    toWeight,
  },
}
</script>

<style lang="scss" scoped>
.dish-card {
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.15s ease;

  &:hover,
  &:focus-visible {
    border-color: var(--v-primary-base);
  }

  &:focus-visible {
    outline: 2px solid var(--v-primary-base);
    outline-offset: 1px;
  }

  &__photo {
    position: relative;

    ::v-deep .dish-image {
      border-radius: 0;
    }
  }

  &__mark {
    position: absolute;
    left: 8px;
    bottom: 8px;
  }

  &__name {
    display: -webkit-box;
    overflow: hidden;
    height: 2.5rem;
    line-height: 1.25rem;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  &__price {
    font-variant-numeric: tabular-nums;
  }
}
</style>
